/**
 * Брендинг «Панели руководителя» Ситуационного центра Атырау.
 *
 * ЕДИНСТВЕННЫЙ ИСТОЧНИК НАЗВАНИЙ И ЛОГОТИПОВ. Ни один компонент не пишет
 * название системы строкой у себя: всё идёт через `BRAND`, поэтому смена
 * заказчика или названия панели — правка одного файла, а не поиск по проекту.
 *
 * ЗНАК И ВОДЯНОЙ ЗНАК — РАЗНЫЕ ФАЙЛЫ, И ЭТО НЕ ДУБЛИРОВАНИЕ. `mark` уходит в
 * CSS `mask-image` (см. `ModuleCardWatermark`), а маска читает только альфу:
 * цветная эмблема с залитым диском дала бы в маске ровный круг. Поэтому под
 * маску лежит отдельный одноцветный силуэт.
 */

export const BRAND = {
  productName: 'Ситуационный центр',
  productShort: 'СЦ',
  systemTitle: 'СЦ Атырау',
  panelTitle: 'Панель руководителя',
  tagline: 'Информационно-аналитическая система\nситуационного центра области',
  copyright: `© ${new Date().getFullYear()} Ситуационный центр Атырауской области. Все права защищены.`,
  copyrightShort: `© ${new Date().getFullYear()} Ситуационный центр Атырау`,
  copyrightPrefix: `© ${new Date().getFullYear()}`,
  eiasFullTitle: 'Ситуационный центр Атырауской области',
  moduleTitle: 'Модуль «Панель руководителя»',
  developer: 'Dreamlab Technologies Ltd',
  developerUrl: 'https://dreamlab.kz',
  supportEmail: 'support@dreamlab.kz',
  supportPhone: '+7 (700) 000-00-58',
} as const

/*
 * ЗНАК — ЛОГОТИП ГОРОДА «ATYRAU», как на веб-витрине (с 28.09.2026 по просьбе
 * заказчика, вместо круглой эмблемы СЦ). Два файла одного рисунка: белые
 * линии на прозрачности — для синих подложек (шапка, панель входа), и тот же
 * знак на синей плашке — для светлых, где белые линии просто исчезли бы.
 * Белый файл — тот же, что `public/brand/atyrau-logo.png` веба, байт в байт.
 *
 * Пропорция ~2 : 1, а не квадрат, как у эмблемы: слоты `BrandMark` задают
 * высоту и `w-auto`, поэтому ширина подстраивается сама.
 *
 * Круглая эмблема (`sc-emblem.svg`, `sc-mark.svg`, `sc-icon.svg`) нигде
 * больше не показывается — ни в шапке, ни в иконках, ни в водяных знаках, —
 * но файлы оставлены: вдруг заказчик вернёт.
 */
export const BRAND_ASSETS = {
  logo: '/brand/atyrau-logo-plate.jpg',
  logoOnDark: '/brand/atyrau-logo.png',
  /**
   * Силуэт под CSS-маску водяных знаков. Маска читает только альфу, поэтому
   * годится белый логотип на прозрачности: его линии и становятся силуэтом,
   * а цвет задаёт `backgroundColor` элемента.
   */
  mark: '/brand/atyrau-logo.png',
  favicon: '/favicon.png',
} as const
